import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TwilioCredentialSource = 'client' | 'region' | 'branch';

export type TwilioCredential = {
  id: string;
  name: string;
  source: TwilioCredentialSource;
  twilioAccountSid: string;
  twilioAuthToken: string;
  messagingSid: string;
  whatsappNumber?: string;
};

type TwilioCredentialState = {
  selectedCredential: TwilioCredential | null;
};

const initialState: TwilioCredentialState = {
  selectedCredential: null,
};

const twilioCredentialSlice = createSlice({
  name: 'twilioCredential',
  initialState,
  reducers: {
    setSelectedTwilioCredential: (
      state,
      action: PayloadAction<TwilioCredential | null>
    ) => {
      state.selectedCredential = action.payload;
    },
    clearSelectedTwilioCredential: (state) => {
      state.selectedCredential = null;
    },
  },
});

export const { setSelectedTwilioCredential, clearSelectedTwilioCredential } =
  twilioCredentialSlice.actions;

export default twilioCredentialSlice.reducer;
